<template>
	<teleport to="body">
		<div class="modal" id="user-identify-modal-google" tabindex="-1" aria-labelledby="modal_example" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content shadow-3">
					<div class="modal-header p-2 border-0">
						<img :src="require(`@/assets/img/illustrations/google-block.jpg`)" class="rounded rounded-2">
					</div>
					<div class="modal-body">
						Google ha deshabilitado su función de inicio de sesión social en el explorador de Instagram. Esto significa que ya no podrán utilizar su cuenta de Google para iniciar sesión dentro de Instagram.<br />
						<br />
						La razón detrás de esta deshabilitación es una decisión tomada por Google y está fuera de nuestro control. Sin embargo, esto no significa que no puedan seguir utilizando el login de Google, para hacerlo, presione los tres puntos de la parte superior derecha y seleccione la opción de abrir en Chrome o Safari.<br />
						<br />
						Lamentamos los inconvenientes que esta decisión pueda causarles y esperamos que comprendan que esto está fuera de nuestro alcance. Si tienen alguna pregunta o inquietud, no duden en ponerse en contacto con nuestro equipo de soporte.
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-sm btn-neutral" data-bs-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</teleport>
</template>